var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSmShare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.69904 13.8224C6.386 13.8224 7.75356 12.4549 7.75356 10.7679C7.75356 9.08093 6.386 7.71338 4.69904 7.71338C3.01208 7.71338 1.64453 9.08093 1.64453 10.7679C1.64453 12.4549 3.01208 13.8224 4.69904 13.8224Z",
    fill: "#848AA0",
    fillOpacity: 0.3,
    stroke: "#848AA0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3026 7.94789C16.9895 7.94789 18.3571 6.58034 18.3571 4.89338C18.3571 3.20642 16.9895 1.83887 15.3026 1.83887C13.6156 1.83887 12.248 3.20642 12.248 4.89338C12.248 6.58034 13.6156 7.94789 15.3026 7.94789Z",
    fill: "#848AA0",
    fillOpacity: 0.3,
    stroke: "#848AA0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3026 19.6959C16.9895 19.6959 18.3571 18.3284 18.3571 16.6414C18.3571 14.9545 16.9895 13.5869 15.3026 13.5869C13.6156 13.5869 12.248 14.9545 12.248 16.6414C12.248 18.3284 13.6156 19.6959 15.3026 19.6959Z",
    fill: "#848AA0",
    fillOpacity: 0.3,
    stroke: "#848AA0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.11524 8.09409C8.90448 6.52093 9.07374 6.50768 12.248 5.6123",
    stroke: "#848AA0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.11524 13.4411C8.90448 15.0142 9.07374 15.0275 12.248 15.9229",
    stroke: "#848AA0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmShare);
export default __webpack_public_path__ + "static/media/sm-share.8d8d56b377a48ecde7deb25b15eeac8f.svg";
export { ForwardRef as ReactComponent };